<app-loading [type]="'spinner'" [showLoading]="showLoading"></app-loading>
<div class="rectangle-header">
    <div class="event-registerd">Demandas cadastradas</div>
</div>

<div class="rectangle-center">
    <mat-accordion>
        <mat-expansion-panel (afterExpand)="loadFilters();">
            <mat-expansion-panel-header >
                <div class="filter-title">
                    Filtrar
                </div>
            </mat-expansion-panel-header>
            <form [formGroup]="filterForm" class="filterForm">
                <div class="filter-container">
                    <mat-form-field>
                        <mat-label>id</mat-label>
                        <input matInput type="text" id="occurrence-id-filter-field" formControlName="occurrenceId" [textMask]="idMask">
                    </mat-form-field>
                    <div class="spacer-fields"></div>
                    <mat-form-field class="occurrence-date-selected">
                        <mat-label>Filtrar por</mat-label>
                        <mat-select #ocurrenceSelectDate formControlName="occurrenceFilterDate"
                            (selectionChange)="onSelectionChange($event)" class="occurrence-date-selection">
                          <mat-option *ngFor="let occurrenceDate of occurrenceDateOptions"
                            [value]="occurrenceDate.value">
                              {{ occurrenceDate.viewValue }}
                          </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="spacer-fields"></div>
                    <mat-form-field class="date-occurrence occurrence-date-selected">
                        <mat-label>
                            data inicial
                        </mat-label>
                        <input matInput id="occurrence-dtStart-filter-field" formControlName="startDate" [matDatepicker]="pickerStartDate" [min]="minDate" maxlength="10" >
                        <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStartDate></mat-datepicker>
                        <mat-error *ngIf="filterForm.errors?.startEndInvalid">
                            A data inicial não pode ser maior que a data final.
                        </mat-error>
                    </mat-form-field>
                    <div class="spacer-fields"></div>
                    <mat-form-field class="date-occurrence">
                        <mat-label>
                            data final
                        </mat-label>
                        <input [required]="filterForm.controls.startDate.value" matInput id="occurrence-dtEnd-filter-field" formControlName="endDate" [matDatepicker]="pickerEndDate" [min]="minDate" maxlength="10" >
                        <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                        <mat-datepicker #pickerEndDate></mat-datepicker>
                        <mat-error *ngIf="filterForm.controls.endDate.errors?.notValid && filterForm.controls.startDate.value">
                            Data final deve ser igual ou maior que à inicial.
                        </mat-error>
                        <mat-error *ngIf="filterForm.controls.endDate.errors?.notValid && !filterForm.controls.startDate.value">
                            Data inicial não pode ser vazia.
                        </mat-error>
                        <mat-error *ngIf="filterForm.controls.endDate.errors?.notComparation">
                            Prazo máximo de 60 dias.
                        </mat-error>
                        <mat-error *ngIf="filterForm.controls.endDate.errors?.required">
                            Data final não pode ser vazia.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="filter-container">
                    <mat-form-field>
                        <mat-label>tipo</mat-label>
                        <mat-select id="occurrence-type-filter-field" formControlName="types" multiple>
                            <mat-option *ngFor="let comboItem of typesCombo" [value]="comboItem.id">{{comboItem.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="spacer-fields"></div>
                    <mat-form-field>
                        <mat-label>CPF/CNPJ</mat-label>
                        <input matInput appCpfCnpj id="occurrence-cpf-filter-field" formControlName="fCpfCnpj" maxlength="18">
                        <mat-error *ngIf="filterForm.controls.fCpfCnpj.errors?.cpfCnpjValidator">
                            CNPJ/CPF inválido.
                        </mat-error>
                    </mat-form-field>
                    <div class="spacer-fields"></div>
                    <mat-form-field>
                        <mat-label>código ou nome fundo/carteira</mat-label>
                        <input matInput id="occurrence-name-filter-field" formControlName="fCode" maxlength="150">
                    </mat-form-field>
                    <div class="spacer-fields"></div>
                    <mat-form-field>
                        <mat-label>
                            status
                        </mat-label>
                        <mat-select id="occurrence-status-filter-field" formControlName="status" multiple>
                            <mat-option *ngFor="let comboItem of statusCombo" [value]="comboItem.id">{{comboItem.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="filter-container align-right">
                    <button class="btn outline mt-10-sm cursor-pointer" type="button" (click)="clearFilter();"><span class="text-blue text-bold">limpar filtro</span></button>
                    <button class="btn orange ml-10-lg mt-10-sm cursor-pointer" type="button" (click)="applyFilter();"><span>aplicar filtro</span></button>
                </div>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<div class="rectangle-center">
    <div class="base">
        <div class="demandas">Demandas</div>
        <button class="button-event" type="submit" (click)="openDialog()" (click)="submitEvent('click', 'criarNovaDemanda', 'criarNovaDemanda')">
            <div class="add-icon">
                <img width="22px" src="./assets/img/icon_add_circle.svg"/>
            </div>
            <span class="create-new-demanda">criar nova demanda</span>
        </button>
    </div>

    <div *ngIf="occurrenceListIsEmpty">
        <div *ngIf="emptyFilter(); else hasFilter">
            <div class="message-without-demanda">Você ainda não tem nenhuma demanda cadastrada. Que tal começar criando uma?</div>
            <button class="button-event-center" type="submit" (click)="openDialog()" (click)="submitEvent('click', 'criarNovaDemanda', 'criarNovaDemanda')">
                <div class="add-icon">
                    <img width="22px" src="./assets/img/icon_add_circle.svg"/>
                </div>
                <span class="create-new-demanda">criar nova demanda</span>
            </button>
        </div>
        <ng-template #hasFilter>
            <div class="flex-message">
                <div class="message-without-filter">
                    Não encontramos nenhuma demanda com os filtros aplicados.
                    Você pode tentar novamente fazendo uma nova busca.
                </div>
                <button class="btn outline mt-10-sm cursor-pointer" type="button" (click)="clearFilter();">
                    <span class="text-blue text-bold">
                        limpar filtro
                    </span>
                </button>
            </div>
        </ng-template>
    </div>

    <div *ngIf="occurrenceListFilterIsEmpty" class="message-without-demanda">Não encontramos nenhuma demanda com os filtros aplicados. Você pode tentar novamente fazendo uma nova busca.</div>

    <div *ngIf="showGrid">
        <table
          mat-table
          [dataSource]="dataSource"
          multiTemplateDataRows
          matSort matSortStart="desc"
          matSortActive="unreadCommentNotification"
          matSortDisableClear
          (matSortChange)="sortOccurrence($event)"
        >

            <ng-container matColumnDef="id">
              <th class="columns-header" mat-header-cell *matHeaderCellDef> id </th>
              <td class="columns-result" mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="database">
                <th class="columns-header middle-small-size" mat-header-cell *matHeaderCellDef mat-sort-header> data da solicitação </th>
                <td class="columns-result middle-small-size" mat-cell *matCellDef="let element">
                    {{ handleNullOrUndefined(element.creationDateTime.split(' ').join('T') | date:'dd/MM/yyyy HH:mm:ss')}}
                </td>
            </ng-container>

            <ng-container matColumnDef="dataevento">
                <th class="columns-header middle-small-size" mat-header-cell *matHeaderCellDef> data do evento </th>
                <td class="columns-result middle-small-size" mat-cell *matCellDef="let element">
                    <div class="occurrence-type-name-container-custom">
                      {{ handleNullOrUndefined(element.eventDate.split(' ').join('T') | date:'dd/MM/yyyy') }}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="tipo">
              <th class="columns-header middle-small-size" mat-header-cell *matHeaderCellDef > tipo </th>
              <td class="columns-result middle-small-size" mat-cell *matCellDef="let element">
                  <div class="button-collapse">
                    <div class="occurrence-type-name-container-custom" [matTooltip]="element.occurrenceTypeName">
                      {{element.occurrenceTypeName}}
                    </div>
                </div>
            </td>
            </ng-container>

            <ng-container matColumnDef="nome" class="occurrence-name-container">
                <th class="columns-header middle-small-size" mat-header-cell *matHeaderCellDef> nome </th>
                <td class="columns-result middle-small-size" mat-cell *matCellDef="let element">
                    <div class="occurrence-type-name-container-custom">
                        <span *ngIf="handlePermissionComment(element.userName) === true && element.unreadCommentNotification">
                            <img [matTooltip]="infoDisabledNotification" class="occurrence-name-notification-img" src="./assets/img/notification.svg">
                        </span>
                        <span [matTooltip]="element.fundName">
                            <b [ngClass]="{'demand-fund-name': element.unreadCommentNotification, 'demand-fund-name-default': !element.unreadCommentNotification}">{{element.fundName}}</b>
                        </span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="cpfcnpj">
              <th class="columns-header" mat-header-cell *matHeaderCellDef> CPF/CNPJ </th>
              <td class="columns-result isDisabled" mat-cell *matCellDef="let element"> <a>{{element.cnpjCpf}}</a> </td>
            </ng-container>

            <ng-container matColumnDef="gestor" class="occurrence-name-container">
                <th class="columns-header middle-small-size" mat-header-cell *matHeaderCellDef> gestor </th>
                <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> <a>{{element.userName}}</a> </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th class="columns-header" mat-header-cell *matHeaderCellDef mat-sort-header> status </th>
              <td class="columns-result" mat-cell *matCellDef="let element">
                <div class="occurrence-name-container-custom" [matTooltip]="element.statusName">
                    {{element.statusName}}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="visualizar">
              <th class="columns-header" mat-header-cell *matHeaderCellDef> visualizar </th>
              <td mat-cell *matCellDef="let element">
                <div class="view-icon" (click)="viewOccurrence(element)" (click)="submitEvent('click', 'visualizarDemanda', 'visualizarDemanda')">
                      <img class="cursor-pointer" width="25px" src="./assets/img/icon-visibility.svg"/>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedTypes">
              <td mat-cell *matCellDef="let element" style="padding: 0 0 0 0 !important;" [attr.colspan]="displayedColumns.length">
                  <div class="types-occurrence-detail"
                      [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'" *ngIf="element.recordStatus === I_INVALID_RECORD_INDICATOR">
                      <table class="expandable-table" mat-table [dataSource]="dataSourceExpandedItem">

                        <ng-container matColumnDef="id">
                            <th class="columns-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="columns-result" mat-cell *matCellDef="let element"></td>
                        </ng-container>

                          <ng-container matColumnDef="database">
                              <mat-header-cell *matHeaderCellDef></mat-header-cell>
                              <th class="columns-header middle-small-size" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                              <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> {{element.creationDateTime | date:'dd/MM/yyyy HH:mm:ss'}} </td>
                          </ng-container>

                          <ng-container matColumnDef="dataevento">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> {{element.eventDate | date:'dd/MM/yyyy'}} </td>
                          </ng-container>

                          <ng-container matColumnDef="tipo">
                              <mat-header-cell *matHeaderCellDef></mat-header-cell>
                              <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> {{element.occurrenceTypeName}} </td>
                          </ng-container>

                          <ng-container matColumnDef="nome" class="occurrence-name-container">
                              <mat-header-cell *matHeaderCellDef></mat-header-cell>
                              <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> {{element.fundName}} </td>
                          </ng-container>

                          <ng-container matColumnDef="cpfcnpj">
                              <mat-header-cell *matHeaderCellDef></mat-header-cell>
                              <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> {{element.cnpjCpf}} </td>
                          </ng-container>

                          <ng-container matColumnDef="gestor">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> {{element.userName}} </td>
                          </ng-container>

                          <ng-container matColumnDef="status">
                              <mat-header-cell *matHeaderCellDef></mat-header-cell>
                              <td class="columns-result middle-small-size" mat-cell *matCellDef="let element"> {{element.statusName}} </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumnsExpandable"></tr>
                          <tr mat-row *matRowDef="let row2; columns: displayedColumnsExpandable;"></tr>
                      </table>
                  </div>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: ['expandedTypes']" class="expanded-element"></tr>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row;columns: displayedColumns;">
            </tr>

          </table>

          <div class="table-footer">
            <mat-paginator
                id="resultPaginator"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="pageSizeOptions"
                (page)="handlePage($event)"
                class="content-gray table-footer-paginator"
            >
            </mat-paginator>
            <button
                class="btn outline mt-10-sm cursor-pointer export-file-button"
                type="button"
                (click)="exportSpreadsheet()"
            >
                <span class="text-blue text-bold export-file-button-text">
                    exportar grid
                </span>
            </button>
        </div>

    </div>
</div>
